const headerTabs = {
    state: {
        activeIndex: '', //激活状态
    },
    getters: {
        activeIndex: state => state.activeIndex
    },
    mutations: {
        // 设置当前激活的tab
        set_active_index(state, index) {
            console.log('??',state, index);
            state.activeIndex = index;
        }
    },
    actions: {

    }
};

export default headerTabs
